import React from 'react';
import {Maybe} from 'monet';
import * as R from 'ramda';

import {useTranslation} from 'react-i18next';
// import download from '@/assets/images/download.png';
import {totalBy, blank, toDollar, present} from '@/util';
import InvestmentHolding from '@/b2c/PlanDetail/Detail/InvestmentHolding';
import CashHolding from '@/b2c/PlanDetail/Detail/CashHolding';

const ValuationCurrencyEquivalent = ({
  valuationCurrency,
  exTotalPortfolioValue,
}) => {
  const {t: tr} = useTranslation('statements');
  const Content = () => (
    <div className='row'>
      <div className='col-sm-6'>
        <p>{tr('total_portfolio_value_in_valuation_currency')}:</p>
      </div>
      <div className='col-sm-6'>
        <p>
          {valuationCurrency} {toDollar(exTotalPortfolioValue)}
        </p>
      </div>
    </div>
  );

  return Maybe.fromFalsy(present(exTotalPortfolioValue))
    .map(() => <Content />)
    .orNull();
};

const totalValuation = totalBy(['valuationValue']);

const buildInvestmentHolding = (planCurrency, productCategory) => ([
  type,
  data,
]) => (
  <InvestmentHolding
    productCategory={productCategory}
    planCurrency={planCurrency}
    type={type}
    data={data}
    key={type}
  />
);

const fundHoldingList = (fundHoldings, planCurrency, productCategory) =>
  R.compose(
    R.map(buildInvestmentHolding(planCurrency, productCategory)),
    R.sortWith([R.descend(R.prop(0))]), // after toPairs, record become [['A', [...]], ['I', [...]]] therefore sort by first prop
    R.toPairs,
    R.groupBy(R.path(['unitType']))
  )(fundHoldings);

const PlanHolding = ({
  plan: {
    holdings,
    currency: planCurrency,
    valuationCurrency,
    productCategory,
    exTotalPortfolioValue,
    companyName,
    ...plan
  },
}) => {
  const {t: tr} = useTranslation('statements');
  const {fund: fundHoldings = [], cash: cashHoldings = []} = R.groupBy(
    R.prop('holdingType')
  )(holdings);

  if (R.path(['totalPortfolioValueAlert'], plan)) {
    return (
      <section>
        <div className='row'>
          <div className='col-sm-12 text-danger'>
            <p>{tr('total_portfolio_value_alert')}</p>
          </div>
        </div>
      </section>
    );
  }

  if (blank(holdings)) {
    return (
      <section>
        <div className='total'>
          <div className='row'>
            <div className='text-right'>
              <p>
                {tr('total_portfolio_value')}: {planCurrency}{' '}
                {totalValuation(holdings)}{' '}
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      {/* FIXME: recover the logic from CAM (for metis account showing fund factsheet download button)
          https://gitlab.abagile.com/abagile/amoeba_cam/blob/master/app/views/statements/policy/_investment.html.haml#L39-42
      <section>
        <h4>Investment Portfolio</h4>
        <hr />
        <a href='/'>
          Portfolio Factsheet
          <img alt='Download' src={download} />
        </a>
      </section>
      */}
      {fundHoldingList(fundHoldings, planCurrency, productCategory)}
      <CashHolding planCurrency={planCurrency} data={cashHoldings} />
      <section>
        <div className='total'>
          <div className='row'>
            <div className='col-sm-6'>
              <p>{tr('total_portfolio_value')}:</p>
            </div>
            <div className='col-sm-6'>
              <p>
                {planCurrency} {toDollar(totalValuation(holdings))}
              </p>
            </div>
          </div>
          <ValuationCurrencyEquivalent
            valuationCurrency={valuationCurrency}
            exTotalPortfolioValue={exTotalPortfolioValue}
          />
        </div>
        <p className='desc'>{tr('disclaimer_1', {companyName})}</p>
      </section>
    </>
  );
};

export {totalValuation, PlanHolding};
